<script lang="ts" setup>
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';

import { useModalsStore } from '@/stores/modals';
import { useCamStore } from '@/stores/cam';
import { useTeaserStore } from '@/stores/teaser';

const route = useRoute();
const router = useRouter();

const { toggleModal, closeModal, getModal } = useModalsStore();

const camStore = useCamStore();
const teaserStore = useTeaserStore();

const isSubmitting = ref(false);

async function end() {
    try {
        isSubmitting.value = true;
        //check if we are in teaser
        if (route.name === 'teaser') {
            await teaserStore.end();
        } else {
            await camStore.end();
        }
        
        isSubmitting.value = false;
        const modal = getModal('close');
        if(modal && modal.next) {
            router.push(modal.next);
        } else {
            const push = route.params.advert ? router.push({ name: 'profile', params: { advert: route.params.advert } }) : router.push({ name: 'grid' });
        }
        
        closeModal('close');
    } catch (ex) {
        isSubmitting.value = false;
        //just throw the error so we can read it in sentry...
        throw ex;
    }
}

function cancel(){
    closeModal('close');
}

</script>

<template src="./modal-close.html"></template>
@/stores/teaser-new